// hooks/useOwnerDashboard.ts — async loader for the owner dashboard.
import { useEffect, useState } from 'react';
import { ownerService } from '@/core/services/ownerService';
import type { OwnerDashboard } from '@/core/models';

export interface OwnerDashboardHook {
  data: OwnerDashboard | null;
  loading: boolean;
  error: string | null;
}

export function useOwnerDashboard(rangeDays = 7): OwnerDashboardHook {
  const [data, setData] = useState<OwnerDashboard | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional loader flag
    setLoading(true);
    ownerService
      .getDashboard(rangeDays)
      .then((d) => { if (alive) { setData(d); setError(null); } })
      .catch(() => { if (alive) setError('Failed to load dashboard'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [rangeDays]);
  return { data, loading, error };
}
